export const RPC_URL = 'https://rpc.l14.lukso.network';
